import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import SmartLink from "../../../../base/links/smart_link.js";

import { AdminUserModel } from "../../../../models/users/admin/user_model.js";

import Routes from "../../../../admin/routes.js";

const contentStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.black,
    textDecoration: "none",
    '&:focus': {
      color: theme.palette.black,
    },
    '&:hover': {
      color: theme.palette.black,
      textDecoration: "underline",
    }
  },
}));

const UserInfoCell = (props) => {
  const { user } = props;
  const displayValue = AdminUserModel.displayValue(user);
  const classes = contentStyles();

  const onClick = (event) => {
    event.stopPropagation();
  }

  if(!user) {
    return <React.Fragment>
      { "-" }
    </React.Fragment>
  }

  return (
    <SmartLink className = { classes.root }
               to = { Routes.user(user) }
               onClick = { onClick } >
      { 
        displayValue !== "" && displayValue !== user.email &&
        <div>
          { displayValue }
        </div>
      }
      <div>
        { user.email }
      </div>
    </SmartLink>
  )
}

export default UserInfoCell;